module.exports = __webpack_public_path__ + "img/afacdf6302b229b5697de54e05974692.48eee89b.webp";